<template>
  <DashboardContainer>
    <v-dialog v-model="showDialog" height="400px" width="600px" persistent>
      <v-card>
        <v-card-title primary-title>Onboarding</v-card-title>
        <v-stepper :value="currentStep">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="currentStep > 1"
              >You</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="currentStep > 2"
              >Company</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="currentStep > 3"
              >Survey</v-stepper-step
            >
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="pa-3">
                <div class="title">Who are you?</div>
                <v-select
                  dense
                  outlined
                  :items="roles"
                  v-model="roleInCompany"
                  label="I'm a ..."
                  class="mt-2"
                  style="width: 300px"
                ></v-select>
                <v-btn
                  color="primary"
                  class="mt-2"
                  :disabled="!roleInCompany"
                  @click="currentStep = 2"
                  >Next</v-btn
                >
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card class="pa-3">
                <div class="title">What is the name of your company?</div>
                <v-text-field
                  label="Name of your company"
                  placeholder="Name of your company"
                  autocomplete="off"
                  outlined
                  dense
                  v-model="companyName"
                  class="mt-2"
                  style="width: 300px"
                ></v-text-field>
                <v-btn
                  color="primary"
                  class="mt-2"
                  :disabled="!companyName"
                  @click="currentStep = 3"
                  >Next</v-btn
                >
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card class="pa-3">
                <div class="title">How did you hear about us?</div>
                <small
                  >It's important for us to identify where our customer comes
                  from.</small
                >
                <v-select
                  dense
                  outlined
                  :items="sources"
                  v-model="howDidYouHearAboutUs"
                  class="mt-2"
                  style="width: 300px"
                ></v-select>
                <v-btn
                  color="primary"
                  class="mt-2"
                  :disabled="!howDidYouHearAboutUs"
                  @click="completeOnboarding()"
                  >Finish</v-btn
                >
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </DashboardContainer>
</template>

<script>
import DashboardContainer from "../components/DashboardContainer";
import axios from "axios";

export default {
  components: {
    DashboardContainer,
  },
  data() {
    return {
      showDialog: true,
      currentStep: 1,
      roleInCompany: "",
      roles: [
        "Product Manager",
        "Sales Person",
        "Founder",
        "Investor",
        "Designer",
        "Consultant",
        "Software Developer",
        "Other",
      ],
      companyName: "",
      howDidYouHearAboutUs: "",
      sources: [
        "ProductHunt",
        "Reddit",
        "IndieHackers",
        "Facebook",
        "Youtube",
        "Linkedin",
        "Ads",
        "Other",
      ],
    };
  },
  methods: {
    async completeOnboarding() {
      this.currentStep = 4;
      await axios.post("/Console/CompleteOnboarding", {
        roleInCompany: this.roleInCompany,
        companyName: this.companyName,
        howDidYouHearAboutUs: this.howDidYouHearAboutUs,
      });
      this.showDialog = false;
      this.$router.push("/");
    },
  },
  created() {
    document.title = "Onboarding - Landly Console";
  },
};
</script>